/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Warehouse_Defects_SubtotalInputs */

const vi_warehouse_defects_subtotal = /** @type {(inputs: Warehouse_Defects_SubtotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tổng kỳ ${i?.period}`)
};

/**

* @param {Warehouse_Defects_SubtotalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_defects_subtotal = /** @type {((inputs: Warehouse_Defects_SubtotalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Defects_SubtotalInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_defects_subtotal(inputs)
});